import React, { Component, Fragment } from "reactn";
import styled from "styled-components";
import { UIPane, UIPaneContents } from "js/react/components/UiComponents";
import { ds } from "js/core/models/dataService";
import { BlueButton } from "js/react/components/UiComponents";
import {
    SlideGalleryDataService,
    SlideTemplateDataService,
    TeamSlideDataService,
    CopySlideDataService
} from "js/react/views/AddSlide/SlideLibraryDataService";
import {
    SlideTemplatesByCategoryList,
    SlideTemplateSearchPreview, SlideTemplateThumbnail,
} from "js/react/views/AddSlide/Panes/SlideTemplatesPane";
import { SlideGalleryPreviewThumbnail } from "js/react/views/AddSlide/Panes/SlideGalleryPane";
import { TeamSlideThumbnail } from "js/react/views/AddSlide/Panes/TeamSlideLibraryPane";
import { CopySlideThumbnail } from "js/react/views/AddSlide/Panes/CopySlidePane";
import { TemplateInfoPane } from "js/react/views/AddSlide/Panes/TemplateInfoPane";
import { SearchShortCuts } from "./Components/SearchShortCuts";
import {
    SearchBarContainer,
    SearchBarInnerContainer,
    UIPaneResultsContainer,
    SlideSearchInput
} from "./Components/SearchBox";
import { NoMatchesFoundContainer } from "./Components/NoMatchesFoundContainer";
import { SlideSearchPreview } from "./Components/SlideSearchPreview";
import { fullTextSearchApi } from "../../../../core/fullTextSearchApi";
import { appSearchNames } from "../../../../config";
import Spinner from "../../../components/Spinner";
import { _ } from "../../../../vendor";
import { SearchThrottleWait, SUGGEST_TEMPLATE_FORM } from "../../../../../common/constants";
import { UIController } from "../../../../editor/dialogs/UIController";
import { Fab, Icon } from "@material-ui/core";
import { Gap10 } from "js/react/components/Gap";

export const SearchPreview = styled.div`
  background: white;
  padding: 20px;
  margin: 0px 0px 20px;
`;
export const SearchPreviewHeader = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-left: 20px;
  margin-bottom: 24px;
  color: #111;
  display: flex;
  align-items: center;
`;

export class SearchSlidesPane extends Component {
    state = {
        query: "",
        isTemplateResultsLoaded: false,
        isGalleryResultsLoaded: false,
        isTeamSlideResultsLoaded: false,
        isCopySlideResultsLoaded: false,
        slideTemplateResults: [],
        slideGalleryResults: [],
        teamSlideResults: [],
        copySlideResults: []
    }

    constructor() {
        super();

        this.searchBarRef = React.createRef();
        this.scrollRef = React.createRef();
        this.fetchTemplateResultsThrottled = _.throttle(this.fetchTemplateResults, SearchThrottleWait, { leading: false });
        this.fetchGalleryResultsThrottled = _.throttle(this.fetchGalleryResults, SearchThrottleWait, { leading: false });
        this.fetchTeamSlideResultsThrottled = _.throttle(this.fetchTeamSlideResults, SearchThrottleWait, { leading: false });
        this.fetchCopySlideResultsThrottled = _.throttle(this.fetchCopySlideResults, SearchThrottleWait, { leading: false });
    }

    componentDidMount() {
        if (!ds.slideTemplateDataService) {
            ds.slideTemplateDataService = new SlideTemplateDataService();
        }
        if (!ds.slideGalleryDataService) {
            ds.slideGalleryDataService = new SlideGalleryDataService();
        }

        if (!ds.teamSlideDataService) {
            ds.teamSlideDataService = new TeamSlideDataService();
        }

        if (!ds.copySlideDataService) {
            ds.copySlideDataService = new CopySlideDataService();
        }

        const promises = [ds.slideTemplateDataService.loadData(), ds.slideGalleryDataService.loadData(), ds.copySlideDataService.loadData(this.props.organizationId)];

        if (UIController.getWorkspaceId() !== "personal") {
            promises.push(ds.teamSlideDataService.loadData(this.props.organizationId));
        }

        Promise.all(promises).then(() => {
            this.setState({
                isTemplateResultsLoaded: true,
                isGalleryResultsLoaded: true,
                isTeamSlideResultsLoaded: true,
                isCopySlideResultsLoaded: true,
            });
            const { query } = this.state;
            this.doSearch(query);
        });
    }

    get areAllSearchResultsLoaded() {
        const { isTemplateResultsLoaded, isCopySlideResultsLoaded, isGalleryResultsLoaded, isTeamSlideResultsLoaded } = this.state;
        const areAllResultsLoaded = isTemplateResultsLoaded && isCopySlideResultsLoaded && isGalleryResultsLoaded;

        if (UIController.getWorkspaceId() !== "personal") {
            return areAllResultsLoaded && isTeamSlideResultsLoaded;
        }

        return areAllResultsLoaded;
    }

    handleSearch = query => {
        this.setState({
            query: query,
            isTemplateResultsLoaded: false,
            isCopySlideResultsLoaded: false,
            isGalleryResultsLoaded: false,
            isTeamSlideResultsLoaded: false,
            selectedShortCut: ""
        });

        this.doSearch(query);
    }

    doSearch = query => {
        if (query == "") {
            this.setState({
                slideTemplateResults: [],
                slideGalleryResults: [],
                teamSlideResults: [],
                copySlideResults: [],
                isTemplateResultsLoaded: true,
                isCopySlideResultsLoaded: true,
                isGalleryResultsLoaded: true,
                isTeamSlideResultsLoaded: true,
            });
        } else {
            this.fetchTemplateResultsThrottled(query);
            this.fetchGalleryResultsThrottled(query);
            this.fetchCopySlideResultsThrottled(query);
            if (UIController.getWorkspaceId() !== "personal") {
                this.fetchTeamSlideResultsThrottled(query);
            }
        }
    }

    fetchTemplateResults = async query => {
        const searchResults = await fullTextSearchApi(query, appSearchNames.templatesSearchEngine);
        this.setState({
            slideTemplateResults: searchResults,
            isTemplateResultsLoaded: true,
        });
    }

    fetchCopySlideResults = async query => {
        const searchResults = await fullTextSearchApi(query, appSearchNames.slidesSearchEngine, [], null, null, { size: 20 });
        this.setState({
            copySlideResults: searchResults.filter(result => result._meta.score > 1),
            isCopySlideResultsLoaded: true,
        });
    }

    fetchTeamSlideResults = async query => {
        const searchResults = await fullTextSearchApi(query, appSearchNames.sharedSlidesSearchEngine, [], null, null, { size: 20 });
        this.setState({
            teamSlideResults: searchResults.filter(result => result._meta.score > 1),
            isTeamSlideResultsLoaded: true,
        });
    }

    fetchGalleryResults = async query => {
        const searchResults = await fullTextSearchApi(query, appSearchNames.inspirationGallerySearchEngine, [], null, null, { size: 20 });
        this.setState({
            slideGalleryResults: searchResults.filter(result => result._meta.score > 1),
            isGalleryResultsLoaded: true,
        });
    }

    handleClearSearch = () => {
        this.searchBarRef.current.updateQuery("");
    }

    handleSelectTemplate = template => {
        if (template.id == "slidePlaceholder") {
            this.props.onTemplateSelected(template);
        } else {
            this.setState({
                selectedTemplate: template
            });
        }
    }

    handleSelectViewAll = pane => {
        const { query } = this.state;
        this.setGlobal({ searchSlidesQuery: query });
        this.props.onSelectViewAll(pane);
    }

    renderSlides = () => {
        const { query, slideTemplateResults, slideGalleryResults, teamSlideResults, copySlideResults } = this.state;

        if (!this.areAllSearchResultsLoaded) {
            return <Spinner />;
        }

        const slideTemplateItems = ds.slideTemplateDataService.getItems(query, slideTemplateResults);
        const slideGalleryItems = ds.slideGalleryDataService.getItems(query, slideGalleryResults);
        const teamSlideItems = ds.teamSlideDataService.getItems(query, teamSlideResults);
        const copySlideItem = ds.copySlideDataService.getItems(query, copySlideResults);
        const hasNoMatches = !slideTemplateItems.length && !slideGalleryItems.length &&
            !teamSlideItems.length && !copySlideItem.length;

        if (query.length > 0 && this.areAllSearchResultsLoaded && hasNoMatches) {
            return (<NoMatchesFoundContainer context="templates" urlSuggestionForm={SUGGEST_TEMPLATE_FORM} onAddClassicSlide={this.props.onAddBlankClassicSlide} />);
        }

        if (query.length > 0) {
            return (
                <div className="search-results-frame">
                    {slideTemplateItems.length > 0 &&
                    <SlideTemplateSearchPreview
                        items={slideTemplateItems}
                        onSelected={this.props.onTemplateSelected}
                        showUserTheme={this.props.showUserTheme}
                        onToggleUserTheme={this.props.onToggleUserTheme}
                    />
                    }
                    {slideGalleryItems.length > 0 &&
                    <SlideSearchPreview
                        title={"Start from our Inspiration Gallery"}
                        thumbnail={SlideGalleryPreviewThumbnail}
                        items={slideGalleryItems}
                        onSelected={this.props.onGallerySlideSelected}
                        onSelectViewAll={() => this.handleSelectViewAll("slide-gallery")}
                        showUserTheme={this.props.showUserTheme}
                        onToggleUserTheme={this.props.onToggleUserTheme}
                    />
                    }
                    {teamSlideItems.length > 0 &&
                    <SlideSearchPreview
                        title={"Start from Team Slides"}
                        thumbnail={TeamSlideThumbnail}
                        items={teamSlideItems}
                        onSelected={this.props.onTeamSlideSelected}
                        onSelectViewAll={() => this.handleSelectViewAll("slide-library")}
                        hideUseCurrentThemeSwitch={true}
                    />
                    }
                    {copySlideItem.length > 0 &&
                    <SlideSearchPreview
                        title={"Start from your Slides"}
                        thumbnail={CopySlideThumbnail}
                        items={copySlideItem}
                        onSelected={slide => this.props.onCopySlideSelected([slide])}
                        onSelectViewAll={() => this.handleSelectViewAll("copy-slide")}
                        hideUseCurrentThemeSwitch={true}
                    />
                    }
                </div>
            );
        }
    }

    render() {
        const { query, selectedTemplate, selectedShortCut } = this.state;

        if (selectedTemplate) {
            return (
                <TemplateInfoPane
                    template={selectedTemplate}
                    onTemplateSelected={this.props.onTemplateSelected}
                    onClassicTemplateSelected={this.props.onClassicTemplateSelected}
                    onGallerySlideSelected={this.props.onGallerySlideSelected}
                    showUserTheme={this.props.showUserTheme}
                    onToggleUserTheme={this.props.onToggleUserTheme}
                />
            );
        }

        return (
            <UIPane>
                <SearchBarContainer>
                    <SearchBarInnerContainer>
                        <SlideSearchInput
                            ref={this.searchBarRef}
                            onSearch={this.handleSearch}
                            placeholder="Search for a slide..."
                            showShortCuts
                        />
                    </SearchBarInnerContainer>
                </SearchBarContainer>
                <UIPaneResultsContainer>
                    {query.length == 0 &&
                        <div className="slide-templates-list">
                            <SlideTemplatesByCategoryList
                                onSelected={this.handleSelectTemplate}
                                hideUseCurrentThemeSwitch={this.props.hideUseCurrentThemeSwitch}
                                showUserTheme={this.props.showUserTheme}
                                onToggleUserTheme={this.props.onToggleUserTheme}
                            />
                        </div>
                    }
                    {this.renderSlides()}
                </UIPaneResultsContainer>
                <Fab
                    variant="extended"
                    className="floating-fab expanding-fab"
                    onClick={()=>window.open(SUGGEST_TEMPLATE_FORM, "_blank")}
                >
                    <Icon className="text-blue">how_to_vote</Icon>
                    <Gap10/>
                    <span>Suggest a template</span>
                </Fab>
            </UIPane>
        );
    }
}
